<link
	rel="preload"
	href="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/HomePersonalBanner/public"
	fetchpriority="high"
	as="image"
/>
<app-page-loader *ngIf="this.isContentLoading"></app-page-loader>

<ng-template #officialHome>
	<div *ngIf="!isContentLoading" class="home-typography">
		<div *ngIf="this.isPersonalFundraising">
			<app-personal-fundraising-divided-banner></app-personal-fundraising-divided-banner>
			<app-featured-fundraisers-homepage></app-featured-fundraisers-homepage>
			<app-starting-a-fundraiser></app-starting-a-fundraiser>
			<app-featured-topics></app-featured-topics>
			<app-start-fundraising-for></app-start-fundraising-for>
			<app-features-and-why-whydonate></app-features-and-why-whydonate>
		</div>
		<div *ngIf="this.isOrganisation">
			<app-organisation-banner></app-organisation-banner>
			<app-fundraising-site></app-fundraising-site>
			<app-donation-plugin></app-donation-plugin>
			<app-multi-team-fundraising></app-multi-team-fundraising>
			<app-starting-a-fundraiser></app-starting-a-fundraiser>
			<app-features-and-why-whydonate></app-features-and-why-whydonate>
			<app-fundraiser-for-global-org></app-fundraiser-for-global-org>
			<app-start-your-fundraiser-org></app-start-your-fundraiser-org>
		</div>
		<app-sub-footer-start-afundraiser></app-sub-footer-start-afundraiser>
	</div>
</ng-template>

<div
	class="custom-theme-branding home-typography body-custom-home"
	*ngIf="isCustomDomainFlag; else officialHome"
>
	<!-- Custom Home Page Component -->
	<div
		*ngIf="isCustomHomePageFlag"
		class="p-l"
		fxLayout="row"
		fxLayoutAlign="center center"
		fxFlex="100"
	>
		<div
			fxLayout="column"
			fxLayoutAlign="center center"
			fxFlex="100"
			fxLayoutGap="1%"
			fxLayoutGap.xs="5%"
		>
			<!--Banner-->
			<div fxLayout="row" fxFlex="100" fxLayoutAlign="center center" fxFill>
				<img width="100%" [src]="this.backgroundImage" />
			</div>
			<br />
			<!--Profile-->
			<div
				fxLayout="row"
				fxLayoutAlign="start start"
				fxLayoutGap="1%"
				fxLayoutGap.xs="3%"
				fxFill
			>
				<div fxLayout="column">
					<img class="profile-image" [src]="this.userImage" />
				</div>
				<div fxLayout="column">
					<strong i18n="@@customDomain_customHome_createdBy">
						Created by:
					</strong>
					<p class="mat-body">{{ this.customHomeProfileData?.name }}</p>
				</div>
			</div>
			<!-- Bio Section -->
			<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2%" fxFill>
				<div
					fxLayout="column"
					fxLayoutAlign="center start"
					fxFlex="100"
					fxLayoutGap="2%"
				>
					<div fxLayout="row" fxLayoutAlign="center center" fxFill>
						<mat-divider class="w-100"></mat-divider>
					</div>

					<p class="mat-body">
						{{ this.customHomeProfileData?.description }}
					</p>
				</div>
			</div>
			<!-- Main Fundraisers Section -->
			<br /><br />
			<div
				*ngIf="this.customHomePageData?.ownedFundraiser?.count > 0"
				fxLayout="row"
				fxLayoutAlign="center center"
				fxLayoutGap="1%"
				fxFill
			>
				<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="2%">
					<div fxLayout="row" fxLayoutAlign="center center" fxFill>
						<mat-divider></mat-divider>
					</div>

					<h2
						i18n="@@customDomain_customHome_mainFundraisers"
						class="dark-grey-texts text-align-center"
					>
						Main Fundraisers
					</h2>
					<br />
					<div
						fxLayout="row"
						fxFlex="100%"
						fxLayout.xs="column"
						fxFlex.xs="100"
						fxLayoutGap="1%"
					>
						<div
							fxLayout="column"
							*ngFor="let _fundraiserCardDataItem of customHomeOwnedFundraisers"
							class="fundraiser-card-custom-home"
						>
							<app-fundraiser-card
								id="fundraiser-card"
								name="fundraiser-card"
								[slug]="_fundraiserCardDataItem.slug"
								[fundraiserCardData]="
									_fundraiserCardDataItem.fundraiserCardData
								"
							></app-fundraiser-card>
						</div>
					</div>
					<div fxLayout="row" fxFlex="100%" fxLayoutAlign="end center" fxFill>
						<button
							i18n="@@customDomain_customHome_viewAll"
							mat-button
							color="accent"
							(click)="routeToSearch('main')"
						>
							View All
						</button>
					</div>
				</div>
			</div>
			<!-- Connected Fundraisers Section -->
			<br /><br />
			<div
				*ngIf="this.customHomePageData?.connectedFundraiser?.count > 0"
				fxLayout="row"
				fxLayoutAlign="center center"
				fxLayoutGap="1%"
			>
				<div
					fxLayout="column"
					fxLayoutAlign="center center"
					fxFlex="100"
					fxLayoutGap="2%"
				>
					<div fxLayout="row" fxLayoutAlign="center center" fxFill>
						<mat-divider></mat-divider>
					</div>

					<h2
						i18n="@@customDomain_customHome_connectedFundraisers"
						class="dark-grey-texts text-align-center"
					>
						Connected Fundraisers
					</h2>
					<br />
					<div
						fxLayout="row"
						fxFlex="100%"
						fxLayout.xs="column"
						fxFlex.xs="100"
						fxLayoutGap="1%"
					>
						<div
							fxLayout="column"
							*ngFor="
								let _fundraiserCardDataItem of customHomeConnectedFundraisers
							"
							class="fundraiser-card-custom-home"
						>
							<app-fundraiser-card
								id="fundraiser-card"
								name="fundraiser-card"
								[slug]="_fundraiserCardDataItem.slug"
								[fundraiserCardData]="
									_fundraiserCardDataItem.fundraiserCardData
								"
							></app-fundraiser-card>
						</div>
					</div>
					<div fxLayout="row" fxFlex="100%" fxLayoutAlign="end center" fxFill>
						<button
							i18n="@@customDomain_customHome_viewAll"
							mat-button
							color="accent"
							(click)="routeToSearch('connected')"
						>
							View All
						</button>
					</div>
				</div>
			</div>
			<!-- Recent Donations Section -->
			<br /><br />
			<div
				*ngIf="this.customHomePageData?.donorList.length > 0"
				fxLayout="row"
				fxLayoutAlign="center center"
				fxLayoutGap="1%"
				fxFlex="60"
				fxFill
			>
				<div
					fxLayout="column"
					fxLayoutAlign="center center"
					fxFlex.xs="100"
					fxFlex="60"
				>
					<h2
						i18n="@@customDomain_customHome_recentDonations"
						class="dark-grey-texts text-align-center"
					>
						Recent Donations
					</h2>
					<br />

					<div
						*ngFor="let donor of this.customHomeRecentDonations; let i = index"
						fxFlex="100"
						fxLayout="row"
						fxLayoutAlign="center center"
						fxFill
					>
						<mat-card class="w-100" [style.border-radius]="0">
							<!--SINGLE DONOR ROW-->
							<mat-card-content
								fxLayout="column"
								fxFlex="100%"
								fxFlex.xs="100%"
								class="p-b-m"
							>
								<div fxLayout="row" fxLayoutAlign="space-between center">
									<!--Avatar-->
									<div
										fxLayout="column"
										fxFlex.xs="20%"
										fxLayoutAlign="start start"
									>
										<img
											mat-card-avatar
											src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor/public"
										/>
									</div>
									<!--Name and Message-->
									<div
										fxLayout="column"
										fxFlex="55%"
										fxLayoutAlign="center start"
										ngClass="p-l-s"
									>
										<div id="donationName">
											<strong> {{ donor?.name }} </strong>
										</div>
										<div>
											{{ donor?.message }}
										</div>
									</div>
									<!--Amount-->
									<div
										fxLayout="column"
										fxFlex="30%"
										fxLayoutAlign="flex-end flex-end"
									>
										<span class="mat-option">
											{{
												donor?.amount
													| currency : donor?.symbol : 'symbol' : '1.0-0'
											}}
										</span>
									</div>
								</div>

								<div fxFlex="100%" fxLayout="row">
									<div fxFlex="14%"></div>
									<div fxLayout="row" fxFlex="100%">
										<div
											fxLayout="row"
											fxLayoutAlign="start center"
											fxFlex="50%"
											fxFlex.xs="80%"
										>
											<div
												*ngIf="
													donor?.reply_message &&
													donor?.reply_message?.length > 1
												"
											>
												<img
													*ngIf="donor?.reply_message"
													width="30"
													height="30"
													loading="lazy"
													src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donor_small/public"
												/>
											</div>
											<div class="m-l-xs">
												{{ donor?.reply_message }}
											</div>
										</div>
									</div>
								</div>
							</mat-card-content>
						</mat-card>
					</div>

					<mat-card *ngIf="!this.customHomeRecentDonations.length">
						<mat-card-content
							fxLayout="row"
							fxLayout.xs="column"
							fxLayoutAlign="center center"
							fxLayoutAlign.xs="start start"
							fxLayoutGap="5%"
						>
							<div
								fxLayout="column"
								fxLayoutAlign="center center"
								fxFlex.xs="100"
							>
								<img width="80px" src="assets/home.png" />
							</div>
							<div fxFlex="column" fxFlex.xs="100">
								<h1 i18n="@@customDomain_customHome_donateFirst">
									Donate First
								</h1>
								<p i18n="@@customDomain_customHome_inspireOthers">
									Inspire others to be the change by Donating to your own
									Fundraiser
								</p>
							</div>
							<div
								fxFlex="column"
								fxLayoutAlign="end end"
								fxFlex.xs="100"
								fxFill
							>
								<button
									i18n="@@customDomain_customHome_donate"
									mat-flat-button
									color="accent"
									class="w-100"
								>
									Donate
								</button>
							</div>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="isCustomFundraiserHomePageFlag">
		<ng-container
			*ngIf="isCustomFundraiserHomePageFlag"
			[ngTemplateOutlet]="fundraiser2"
		></ng-container>
	</div>
</div>

<ng-template #fundraiser2> <app-fundraiser></app-fundraiser></ng-template>

<ng-template #fundraiser>
	<div *ngIf="isFundraiserDataLoaded" class="custom-theme-branding p-m">
		<ng-template
			[ngIf]="_media.isActive('lt-sm') || _media.isActive('gt-sm')"
			[ngIfElse]="tabletView"
		>
			<div
				[fxHide]="isViewChanging"
				fxLayout="row"
				fxLayout.lt-md="column"
				fxLayoutAlign="center"
				fxLayoutGap="1.5%"
				class="mat-typography p-b-s"
			>
				<div fxFlex="70%">
					<ng-container
						[ngTemplateOutlet]="fundraiserBackground"
					></ng-container>
					<ng-container [ngTemplateOutlet]="fundraiserTitle"></ng-container>
					<mat-divider></mat-divider>
					<ng-container [ngTemplateOutlet]="fundraiserOwnerInfo"></ng-container>
					<mat-divider></mat-divider>
					<ng-container
						*ngIf="isCurrentChildFundraiser"
						[ngTemplateOutlet]="appealByChildFundraiser"
					></ng-container>
					<br />
					<ng-container [ngTemplateOutlet]="aboutAndConnectTab"></ng-container>
					<br />
				</div>
				<div fxFlex="30%">
					<ng-container [ngTemplateOutlet]="fundraiserDonation"></ng-container>
					<br />
					<ng-container [ngTemplateOutlet]="supportFundraiser"></ng-container>
					<br />
					<ng-container [ngTemplateOutlet]="donationList"></ng-container>
				</div>
			</div>
			<button
				mat-stroked-button
				color="accent"
				(click)="routeToMarkFundraiserFraudulent()"
			>
				<img
					class="icon-background"
					height="16px"
					src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/flagAction/public"
				/>
				<span i18n="@@button_report_fraudulent">Report Fundraiser</span>
			</button>
		</ng-template>
	</div>
</ng-template>

<!-- show page loader if isViewChanging is true -->
<ng-container
	*ngIf="isViewChanging"
	[ngTemplateOutlet]="whydonateLoader"
></ng-container>

<!-- Responsive: Tablet -->
<ng-template #tabletView>
	<div [fxHide]="isViewChanging" class="mat-typography">
		<!-- Background image -->
		<ng-container [ngTemplateOutlet]="fundraiserBackground"></ng-container>
		<!-- Title row -->
		<ng-container [ngTemplateOutlet]="fundraiserTitle"></ng-container>
		<mat-divider></mat-divider>
		<!-- Fundraiser owner info row -->
		<ng-container [ngTemplateOutlet]="fundraiserOwnerInfo"></ng-container>
		<mat-divider></mat-divider>
		<br />
		<div fxLayout="row">
			<div fxFlex="50%">
				<ng-container [ngTemplateOutlet]="fundraiserDonation"></ng-container>
			</div>
		</div>
		<ng-container
			*ngIf="isCurrentChildFundraiser"
			[ngTemplateOutlet]="appealByChildFundraiser"
		></ng-container>
		<br />
		<ng-container [ngTemplateOutlet]="aboutAndConnectTab"></ng-container>
		<br />
		<div fxLayout="row" fxLayoutGap="16px" class="p-b-s">
			<div fxFlex="50%">
				<ng-container [ngTemplateOutlet]="supportFundraiser"></ng-container>
			</div>
			<div fxFlex="50%">
				<ng-container [ngTemplateOutlet]="donationList"></ng-container>
			</div>
		</div>
		<button
			mat-stroked-button
			color="accent"
			(click)="routeToMarkFundraiserFraudulent()"
		>
			<img
				height="16px"
				src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/flagAction/public"
			/>
			<span i18n="@@button_report_fraudulent">Report Fundraiser</span>
		</button>
	</div>
</ng-template>
<!-- START Subcomponents Templates -->

<!-- Background Image -->
<ng-template #fundraiserBackground>
	<!-- Background Image - VIEW -->

	<div fxLayoutAlign="end end">
		<div
			class="w-100 aspect-ratio"
			*ngIf="backgroundVideo.length > 0"
			[innerHTML]="youtubeIframe"
		></div>

		<img
			class="w-100 aspect-ratio"
			*ngIf="backgroundImage.length > 0"
			[src]="backgroundImage"
			(error)="fallbackToDefaultImage()"
		/>
	</div>
</ng-template>
<!-- Title -->
<ng-template #fundraiserTitle>
	<!-- Title - VIEW -->
	<ng-template [ngIf]="!(this.showEdits && this.isLoggedInUserAdmin)"
		><h1 class="p-t-s mat-headline-6">
			<strong
				*ngIf="(currentFundraiser?.translations?.['title' + localeSuffix]) else defaultTitle"
				>{{ currentFundraiser?.translations?.['title' + localeSuffix] }} ||
				{{ currentFundraiser?.title }}
			</strong>
			<ng-template #defaultTitle>
				<strong>
					{{ currentFundraiser?.title }}
				</strong></ng-template
			>
		</h1>
		<div
			fxLayout="row"
			fxLayoutGap="20px"
			fxLayoutGap.xs="10px"
			fxLayoutAlign="space-between"
			ngClass="isWhydonateSecondaryColor ? whydonate-light : branding-light"
			fxLayoutAlign.xs="start"
			fxLayout.xs="column"
		>
			<div
				fxLayout="row"
				fxLayout.xs="column"
				fxLayoutGap.xs="10px"
				fxLayoutAlign="center center"
				fxLayoutAlign.xs="start start"
			>
				<div fxLayout="row" fxLayoutAlign="center center">
					<app-fundraiser-category
						[category]="this.currentFundraiser?.category"
					>
					</app-fundraiser-category>
				</div>

				<div
					*ngIf="
						!isCurrentChildFundraiser ||
						(isCurrentChildFundraiser &&
							this.currentFundraiser?.root_fundraiser?.location)
					"
					fxLayout="row"
					fxFlexOffset="32px"
					fxFlexOffset.xs="0px"
					fxLayoutAlign="center center"
				>
					<app-fundraiser-location
						[currentFundraiser]="this.currentFundraiser"
					></app-fundraiser-location>
				</div>
			</div>

			<!-- <div
				*ngIf="
					this.currentFundraiser?.social_media?.instagram == '' &&
					this.currentFundraiser?.social_media?.facebook == '' &&
					this.currentFundraiser?.social_media?.linkedin == '' &&
					this.currentFundraiser?.social_media?.website == '' &&
					this.currentFundraiser?.social_media?.email == '' &&
					this.currentFundraiser?.social_media?.twitter == ''
				"
				fxLayout="row"
				fxLayoutGap="0"
				fxLayoutAlign="center center"
				fxLayoutAlign.xs="start center"
			>
				<span i18n="@@editFundraiser_thisIsASupportingFundraiser_contact">
					Contact:
				</span>
				<span
					*ngIf="
						!(isCurrentChildFundraiser
							? !(
									this.currentFundraiser?.root_fundraiser?.social_media
										?.instagram == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.facebook == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.linkedin == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.website == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.email == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.twitter == ''
							  )
							: !(
									this.currentFundraiser?.social_media?.instagram == '' &&
									this.currentFundraiser?.social_media?.facebook == '' &&
									this.currentFundraiser?.social_media?.linkedin == '' &&
									this.currentFundraiser?.social_media?.website == '' &&
									this.currentFundraiser?.social_media?.email == '' &&
									this.currentFundraiser?.social_media?.twitter == ''
							  ))
					"
				>
					<mat-chip fxFlexOffset="6px">
						<span
							i18n="@@editFundraiser_thisIsASupportingFundraiser_contact_label"
						>
							Not Available
						</span>
					</mat-chip>
				</span>
				<app-owner-social-share
					*ngIf="
						isCurrentChildFundraiser
							? !(
									this.currentFundraiser?.root_fundraiser?.social_media
										?.instagram == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.facebook == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.linkedin == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.website == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.email == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.twitter == ''
							  )
							: !(
									this.currentFundraiser?.social_media?.instagram == '' &&
									this.currentFundraiser?.social_media?.facebook == '' &&
									this.currentFundraiser?.social_media?.linkedin == '' &&
									this.currentFundraiser?.social_media?.website == '' &&
									this.currentFundraiser?.social_media?.email == '' &&
									this.currentFundraiser?.social_media?.twitter == ''
							  )
					"
					ngClass="p-0"
					fxLayout="row"
					fxLayoutAlign="center center"
					[isLoggedIn]="showEdits"
					[socialMedia]="this.currentFundraiser?.root_fundraiser?.social_media"
				></app-owner-social-share>
			</div> -->

			<!-- <div
				*ngIf="
					this.currentFundraiser?.social_media?.instagram != '' ||
					this.currentFundraiser?.social_media?.facebook != '' ||
					this.currentFundraiser?.social_media?.linkedin != '' ||
					this.currentFundraiser?.social_media?.website != '' ||
					this.currentFundraiser?.social_media?.email != '' ||
					this.currentFundraiser?.social_media?.twitter != ''
				"
				fxLayout="row"
				fxLayoutGap="0"
				fxLayoutAlign="center center"
				fxLayoutAlign.xs="start center"
			>
				<span i18n="@@editFundraiser_thisIsASupportingFundraiser_contact">
					Contact:
				</span>
				<app-owner-social-share
					*ngIf="
						isCurrentChildFundraiser
							? !(
									this.currentFundraiser?.root_fundraiser?.social_media
										?.instagram == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.facebook == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.linkedin == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.website == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.email == '' &&
									this.currentFundraiser?.root_fundraiser?.social_media
										?.twitter == ''
							  )
							: !(
									this.currentFundraiser?.social_media?.instagram == '' &&
									this.currentFundraiser?.social_media?.facebook == '' &&
									this.currentFundraiser?.social_media?.linkedin == '' &&
									this.currentFundraiser?.social_media?.website == '' &&
									this.currentFundraiser?.social_media?.email == '' &&
									this.currentFundraiser?.social_media?.twitter == ''
							  )
					"
					ngClass="p-0"
					fxLayout="row"
					fxLayoutAlign="center center"
					[isLoggedIn]="showEdits"
					[socialMedia]="this.currentFundraiser?.social_media"
				></app-owner-social-share>
			</div> -->
		</div>

		<br />
	</ng-template>
</ng-template>

<!-- Fundraiser Owner Info -->
<ng-template #fundraiserOwnerInfo>
	<!--Fundraiser Owner, social media, location and connect with-->
	<ng-template
		[ngIf]="!isCurrentChildFundraiser"
		[ngIfElse]="threeColumnsLayout"
	>
		<div
			fxLayout="row"
			fxLayoutGap.xs="15px"
			fxLayoutGap="150px"
			fxLayout.xs="column"
			class="m-t-m m-b-xl"
		>
			<div fxLayout="row" fxLayoutGap="0px" fxLayoutAlign="space-between">
				<app-created-by [currentFundraiser]="this.currentFundraiser">
				</app-created-by>
			</div>
			<div
				fxLayout="row"
				fxLayoutGap.xs="0px"
				fxLayoutGap="30px"
				fxLayoutAlign="start"
			>
				<app-opp-owner [bankAccount]="this.currentFundraiser"> </app-opp-owner>
			</div>
		</div>
	</ng-template>
	<!-- if current is connected/child fundraiser then pick below layout -->
	<ng-template #threeColumnsLayout>
		<div
			fxLayout="row"
			class="p-t-m p-b-m"
			fxLayoutAlign="space-between"
			fxLayout.xs="column"
			fxLayoutGap.xs="30px"
		>
			<div>
				<app-created-by [currentFundraiser]="this.currentFundraiser">
				</app-created-by>
			</div>
			<div>
				<app-opp-owner [bankAccount]="this.currentFundraiser"></app-opp-owner>
			</div>
			<div *ngIf="isCurrentChildFundraiser">
				<div
					fxLayout="row"
					class="clickable"
					fxFlex.xs
					(click)="
						routeToParentFundraiser(this.currentFundraiser?.parent?.slug)
					"
				>
					<img
						class="profile-image"
						src="{{ this.currentFundraiser?.parent?.profile?.image }}"
						(error)="handleImageError($event)"
					/>
					<div class="m-l-s" fxLayout="column">
						<mat-label i18n="@@editFundraier_connectedWith_label"
							>Connected with:</mat-label
						>
						<div>
							{{
								this.currentFundraiser?.parent?.parent_translations[
									'title' + localeSuffix
								] || this.currentFundraiser?.parent?.title
							}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</ng-template>

<!-- Apeal by connected fundraiser -->
<ng-template #appealByChildFundraiser>
	<div class="grey-bg m-t-m">
		<div fxLayout="row" fxLayoutAlign="space-between center">
			<div fxFlex ngClass="p-m" i18n="@@editFundraiser_appealForCause_label">
				Appeal for cause
			</div>
		</div>
		<mat-divider></mat-divider>
		<ng-template [ngIf]="!this.isDescriptionLoaded">
			<div
				class="p-xl mat-headline-6"
				fxLayout="column"
				fxLayoutAlign="center center"
			>
				<div
					class="dark-grey-texts mat-subtitle-2"
					i18n="@@appeal_loading_please_wait"
				>
					Fundraiser appeal translation is in progress, this can take a few
					minutes...
				</div>
			</div>
		</ng-template>
		<quill-view
			[content]="
				currentFundraiser?.translations['content' + localeSuffix] ||
				currentFundraiser?.content
			"
			[preserveWhitespace]="true"
			[sanitize]="true"
			format="html"
		></quill-view>
		<div ngClass="p-b-m">
			<a i18n="@@share_update_messageReadmore" class="read-more cursor-pointer">
				Read More
			</a>
		</div>
		<div
			*ngIf="this.currentFundraiser?.appeal_image_list[0]"
			class="m-l-s p-b-s"
		>
			<ng-image-slider
				[images]="appealMediaList"
				[imageSize]="{ height: 150 }"
				[manageImageRatio]="true"
				[imagePopup]="false"
			    (imageClick)="openCustomDialog($event, appealMediaList)"
				[showArrow]="mediaLength > 2 ? true : false"
				#nav
			></ng-image-slider>
		</div>
	</div>
</ng-template>

<!-- About & Connect Fundraiser Tab -->
<ng-template #aboutAndConnectTab>
	<mat-tab-group dynamicHeight>
		<mat-tab id="editFundraiser_about_template">
			<ng-template
				matTabLabel
				class="p-t-l"
				i18n="@@editFundraiser_about_template"
				>About
			</ng-template>
			<ng-template matTabContent>
				<ng-container [ngTemplateOutlet]="aboutTabContent"></ng-container>
			</ng-template>
		</mat-tab>
		<mat-tab class="p-s">
			<ng-template matTabLabel class="p-t-l"
				><span
					id="editFundraiserConnectedFundraisersHeading"
					i18n="@@editFundraiser_connectedFundraisers_heading"
					>Connected Fundraisers</span
				>
				<ng-template
					[ngIf]="!isConnectedFundraiserCountLoading"
					[ngIfElse]="spinner"
				>
					&nbsp;({{ connectedFundraisersCount }})
				</ng-template>
			</ng-template>
			<ng-template matTabContent>
				<ng-container [ngTemplateOutlet]="connectedTabContent"></ng-container>
			</ng-template>
		</mat-tab>
	</mat-tab-group>

	<!-- About Tab Content -->
	<ng-template #aboutTabContent>
		<ng-template [ngIf]="!isCurrentChildFundraiser">
			<mat-divider></mat-divider>
		</ng-template>

		<ng-template [ngIf]="fundraiserNoDescription && isDescriptionLoaded">
			<br />
			<div
				class="pale-grey-bg"
				[ngClass]="{ 'p-xl': showEdits, 'p-xxl': !showEdits }"
				fxLayout="column"
				fxLayoutAlign="center center"
			>
				<div class="center" *ngIf="!showEdits">
					<img
						src="https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/poetry/public"
					/>
				</div>
				<div
					class="center"
					*ngIf="!showEdits"
					i18n="@@add_fundraiser_no_description_body_other_user"
				>
					Fundraiser's story is currently in progress.
				</div>
				<br />
			</div>
		</ng-template>

		<ng-template [ngIf]="!this.isDescriptionLoaded">
			<div
				class="p-xl mat-headline-6"
				fxLayout="column"
				fxLayoutAlign="center center"
			>
				<div
					class="dark-grey-texts mat-subtitle-2"
					i18n="@@description_loading_please_wait"
				>
					Fundraiser description translation is in progress, this can take a few
					minutes...
				</div>
			</div>
		</ng-template>
		<app-fundraiser-about
			*ngIf="
				(!isNewFundraiser || isCurrentChildFundraiser) &&
				!fundraiserNoDescription
			"
			[currentFundraiser]="this.currentFundraiser"
			[isChildFundraiser]="this.isCurrentChildFundraiser"
			[fundraiserDescriptionData]="this.fundraiserDescriptionData"
			[isLoading]="this.isDescriptionLoaded"
			(readMoreClicked)="getFundraiserFullDescription($event)"
		></app-fundraiser-about>

		<!-- UPDATES -->
		<div ngClass="p-t-l"></div>
		<ng-container [ngTemplateOutlet]="fundraiserUpdates"></ng-container>
	</ng-template>
	<!-- About Tab Media -->
	<ng-template #aboutTabMedia>
		<br />
		<app-fundraiser-media-view
			[currentFundraiser]="this.currentFundraiser"
		></app-fundraiser-media-view>
	</ng-template>

	<!-- Connected Tab -->
	<ng-template #connectedTabContent>
		<br />
		<ng-template [ngIf]="connectedFundraisersData?.length" [ngIfElse]="zeroDay">
			<div fxLayout="column">
				<div
					fxLayout="row"
					fxLayout.xs="column"
					fxLayoutAlign="space-between baseline"
					fxFlex="100%"
					fxLayoutGap.sm="3%"
					fxLayoutGap.lt-sm="0%"
				>
					<div fxFlex="70%" fxLayout="column"></div>
					<div fxFlex="25%" fxFlex.sm="30%" fxLayout="column">
						<button
							mat-stroked-button
							color="accent"
							(click)="routeToConnectFundraiser()"
							[disabled]="currentFundraiser?.allow_child === false"
						>
							<span i18n="@@button_connectFundraiser"
								>Create Connect Fundraiser</span
							>
						</button>
					</div>
				</div>
				<div
					*ngIf="connectedFundraisersData?.length"
					fxLayout="row wrap"
					fxLayoutAlign="center start"
					class="fundraiser-card"
				>
					<div *ngFor="let _fundraiserCardDataItem of connectedFundraisersData">
						<app-fundraiser-card
							[slug]="_fundraiserCardDataItem.slug"
							[fundraiserCardData]="_fundraiserCardDataItem.fundraiserCardData"
						>
						</app-fundraiser-card>
					</div>
				</div>
			</div>
			<div fxLayoutAlign="center center">
				<button
					id="view-more-button-connected-fundraiser"
					name="view-more-button"
					mat-flat-button
					color="accent"
					(click)="viewMore()"
					[disabled]="
						this.isConnectedFundraiserCountLoading ||
						this.connectedFundraisersData.length ==
							this.connectedFundraisersCount
					"
				>
					<span i18n="@@search_fundraiser_button_title_read_more_button"
						>View More</span
					>
					<mat-icon *ngIf="this.isConnectedFundraiserCountLoading">
						<mat-spinner color="primary" diameter="16" i18n="@@search_spinner">
						</mat-spinner>
					</mat-icon>
				</button>
			</div>
		</ng-template>
		<ng-template #zeroDay>
			<div
				class="pale-grey-bg p-xl"
				fxLayout="column"
				fxLayoutAlign="center center"
			>
				<div
					class="mat-headline-6 center"
					i18n="@@edit_fundraiser_connectedTab_zeroDay_title"
				>
					Build Connected Fundraiser
				</div>
				<div fxLayout="row">
					<div
						fxFlex.gt-xs="300px"
						class="center"
						i18n="@@edit_fundraiser_connectedTab_zeroDay_body"
					>
						Start a new connect fundraiser to raise money for your loved ones or
						cause you care for.
					</div>
				</div>
				<br />
				<button
					i18n="@@button_connectFundraiser"
					mat-stroked-button
					id="editFundraiserConnectFundraiserButton"
					color="accent"
					(click)="routeToConnectFundraiser()"
					[disabled]="currentFundraiser?.allow_child === false"
					matTooltip="{{ this.disableTooltip }}"
					[matTooltipDisabled]="currentFundraiser?.allow_child === true"
				>
					Connect Fundraiser
				</button>
			</div>
		</ng-template>
	</ng-template>
</ng-template>

<!-- Fundraiser Updates -->

<ng-template #fundraiserUpdates>
	<ng-template [ngIf]="!this.isUpdateLoaded">
		<mat-divider></mat-divider>
		<div
			class="p-t-xxl p-l mat-headline-6"
			fxLayout="column"
			fxLayoutAlign="center center"
		>
			<div
				class="dark-grey-texts mat-subtitle-2"
				i18n="@@update_loading_please_wait"
			>
				Fundraiser update translation is in progress, this can take a few
				minutes...
			</div>
		</div>
	</ng-template>
	<ng-template [ngIf]="this.isUpdateLoaded">
		<app-fundraiser-update-view
			*ngIf="this.isUpdateLoaded"
			(loadFullUpdateEvent)="loadFullUpdateEvent($event)"
			[fundraiserUpdates]="this.fundraiserUpdatesData"
			[cardShadow]="cardShadow"
			[slug]="this.currentFundraiser?.slug"
			[currentFundraiser]="this.currentFundraiser"
			[count]="this.fundraiserUpdatesCount"
			[totalPages]="this.fundraiserUpdatesTotalPages"
		></app-fundraiser-update-view>
	</ng-template>
</ng-template>

<ng-template #fundraiserDonation>
	<mat-card class="mat-elevation-z{{ cardShadow }}" ngClass.xs="sticky">
		<mat-card-content>
			<app-fundraiser-donation
				[fundraiserCardData]="fundraiserCardData"
				[targetAmount]="this.currentFundraiser.amount_target"
				[raisedAmount]="this.currentFundraiser.donation.amount"
				[selectedFundraiser]="this.currentFundraiser"
				[showEdits]="showEdits"
				[isDraftOrClosed]="isDraftOrClosed"
				[isNewFundraiser]="isNewFundraiser"
				[daysLeft]="this.daysLeft"
				[isLoggedIn]="isLoggedInUserAdmin"
				[isFindable]="this.currentFundraiser.is_findable"
				[isOpen]="this.currentFundraiser.is_opened"
				[isDraft]="this.currentFundraiser.is_draft"
			>
			</app-fundraiser-donation>
		</mat-card-content>
	</mat-card>
</ng-template>

<ng-template #donationList>
	<mat-card
		class="m-b-xl"
		*ngIf="this.donarDataParent <= 0"
		class="mat-elevation-z{{ cardShadow }}"
	>
	    <mat-card-content>
			<app-donations-zero
				[isLoggedInUserAdmin]="isLoggedInUserAdmin"
				[hideToggleSwitch]="hideToggleSwitch"
				[donationReceivedBoolean]="this.currentFundraiser.show_received_donations"
			></app-donations-zero>
		</mat-card-content>
	</mat-card>
	<mat-card
		*ngIf="
			this.donarDataParent > 0 && this.currentFundraiser.show_received_donations
		"
		class="mat-elevation-z{{ cardShadow }}"
	>
	    <mat-card-content>
			<app-donor-list-short
				[currentFundraiserID]="this.currentFundraiser.id"
				[isLoggedInUserAdmin]="isLoggedInUserAdmin"
				[donationReceivedBoolean]="this.currentFundraiser.show_received_donations"
				[hideToggleSwitch]="hideToggleSwitch"
				[donorShortData]="this.donorShortData"
			></app-donor-list-short>
		</mat-card-content>
	</mat-card>
</ng-template>

<ng-template #supportFundraiser>
	<ng-container *ngIf="currentFundraiser?.allow_child || this.showEdits">
		<mat-card class="mat-elevation-z{{ cardShadow }}">
			<mat-card-content>
				<app-connect-fund
					[slug]="this.currentFundraiser.slug"
					[isAllowChild]="currentFundraiser?.allow_child"
					[isLoggedInUserAdmin]="isLoggedInUserAdmin"
					[hideToggleSwitch]="hideToggleSwitch"
				></app-connect-fund>
			</mat-card-content>
		</mat-card>
	</ng-container>
</ng-template>

<ng-template #whydonateLoader>
	<app-page-loader></app-page-loader>
</ng-template>
<ng-template #spinner>
	<mat-icon>
		<mat-spinner color="primary" diameter="16"> </mat-spinner>
	</mat-icon>
</ng-template>
